import { Autocomplete, Box, Button, Card, Checkbox, Chip, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, set, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { EventContext } from '.';
import ImgUploadDialog from '../../../components/ImgUpload/imgUpload';
import { Helpers } from '../../../services/Helpers';
import { AddToPhotos, CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { EventServices } from './EventServices';
import { PermissionGuard } from '../../../components/PermissionGuard';
// import { PermissionGuard } from '../../../../components/PermissionGuard';
// import UnauthorizedPage from '../../../UnAuthorized';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

const AddEditEvent = () => {
    const { eventInitialData,eventData,setEventData,fetchEventList,eventList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedEventData, setSelectedEventData} = useContext(EventContext)
    const [pageTitle, setPageTitle] = useState('Add Brand');
    const {control,handleSubmit,formState:{errors,isDirty},reset,watch,setValue,clearErrors} = useForm({
        mode:'onChange',
        defaultValues:eventData,
    });
    const [isSubmitted,setIsSubmitted] = useState(false);
    const resetForm = () => {
    // Reset form to initial values
    reset(eventInitialData, { keepDirty: false }); 
    // Clear context data
    setSelectedEventData(null);
    setEventData(eventInitialData);
}

    const onSubmit = async (data)=>{
        const result = await Swal.fire({
            title: 'are you sure?',
            text: `Do you want to ${selectedEventData?'update':'save'} this data?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Yes, ${selectedEventData?'update':'save'}`,
            cancelButtonText: 'No, cancel',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCloseButton: false,
        });
        if(result.isConfirmed){
            Swal.fire({
                title: `Please wait...`,
                text:   `while we ${selectedEventData?'updating':'saving'} your data `,
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            // setIsSubmitted(true);
            console.log("data:",data);
            const ModifiedData = {
                title: data.title,
                description: data.description,
                image: data.image,
            }
            try{
                if(selectedEventData){
                    //update
                    const updateresponse = await EventServices.updateEvent(ModifiedData,selectedEventData.id);
                    if(updateresponse.success == '1'){
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Data updated successfully',
                            timer:1000
                        })
                        fetchEventList();
                        resetForm();
                    }else if(updateresponse.success == '0'){                    
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: updateresponse.message || 'failed to update data',
                        })
                    }
                }else{
                    //save
                    const saveresponse = await EventServices.addEvent(ModifiedData);
                    if(saveresponse.success == '1'){
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Data saved successfully',
                            timer:1000
                        })
                        fetchEventList();
                        resetForm();
                    }else if(saveresponse.success == '0'){
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: saveresponse.message || 'failed to save data',
                        })
                    }
                }
            }catch (error){
                console.log("error:",error)
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'failed to save data...Something went wrong!',
                })
            }
        }
        
    }
    useEffect(()=>{
        if(selectedEventData){
            setPageTitle('Edit Event');
            const modifiedData = {
                ...selectedEventData,
            }

            setEventData(modifiedData);
            reset(modifiedData,{isDirty:false});
        }else{
            setPageTitle('Add Event');
        }
    },[selectedEventData])
  return (
    <Card>
        <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
            <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >{pageTitle}</Typography>
        </Box>
        <Box component={'form'} onSubmit={handleSubmit(onSubmit)} sx={{p:1}}>                
            <Grid container spacing={2}>                    
                <Grid item xs={12}>
                    <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Title <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                    <Controller
                        name='title'
                        control={control}
                        rules={{
                            required:'title required',
                        }}
                        render={({field,fieldState:{error}})=>
                            <TextField
                                {...field}
                                size='small'
                                fullWidth
                                // type='number'
                                error={!!error}
                                inputProps={{
                                    style:{
                                        fontSize:'0.65rem'
                                    },
                                }}
                            />
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Description</Typography>
                            <Controller
                                name='description'
                                control={control}
                                rules={{
                                    // required:'description required',
                                }}
                                render={({field,fieldState:{error}})=>
                                    <TextField
                                        {...field}
                                        size='small'
                                        fullWidth
                                        multiline
                                        minRows={3}
                                        // type='number'
                                        error={!!error}
                                        inputProps={{
                                            style:{
                                                fontSize:'0.65rem'
                                            },
                                        }}
                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                </Grid>
                
                
                <Grid item xs={12} sx={{display:'flex',justifyContent:'center',gap:2}}>
                    <Button 
                        variant='contained' 
                        size='small' 
                        color='error'
                        onClick={resetForm}
                        disabled={selectedEventData?false:!isDirty}
                    >
                        Cancel
                    </Button>
                    <PermissionGuard feature={'lyns-events'} permission='canCreate'>
                        {!selectedEventData && <Button 
                            variant='contained' 
                            size='small' 
                            type='submit'
                            disabled={!isDirty}
                        >
                            Save
                        </Button>}
                    </PermissionGuard>
                    <PermissionGuard feature={'lyns-events'} permission='canEdit'>
                        {selectedEventData && <Button 
                            variant='contained' 
                            size='small' 
                            type='submit'
                            disabled={!isDirty}
                        >
                            Update
                        </Button>}
                    </PermissionGuard>                        
                </Grid>
            </Grid>                              
        </Box>
    </Card>
  );
}

export default AddEditEvent;
const formatValue = (value) => {
    if (typeof value !== 'string') {
      return value === 0 ? 0 : value?.toString() || '';
    }
    const formatted = value.replace(/^0+(?=\d)/, '').replace(/^\./, '0.');
    return formatted === '' ? '' : formatted;
};